import { useMutation } from '@tanstack/react-query';

import apiClient from '@/constants/http';
import { Logger } from '@/utils/logging';

import type {
  PurchaseGiftCardParams,
  PurchaseGiftCardResponse,
  UsePurchaseGiftCardMutationOptions,
} from './types';

async function purchaseGiftCard(
  params: PurchaseGiftCardParams,
): Promise<PurchaseGiftCardResponse> {
  const { shopId, ...payload } = params;
  const { data } = await apiClient.post<PurchaseGiftCardResponse>(
    `/v1/shop/${shopId}/customer-gift-card`,
    payload,
    { timeout: 15000 },
  );
  return data;
}

export function usePurchaseGiftCardMutation(
  options?: UsePurchaseGiftCardMutationOptions,
) {
  return useMutation({
    ...options,
    retry: false,
    mutationFn: purchaseGiftCard,
    onError: (error, variables, context, mutationContext) => {
      Logger.error('Error purchasing gift card', { error, variables });
      options?.onError?.(error, variables, context, mutationContext);
    },
  });
}
